import { blue, cyan, purple, yellow } from "designSystem/styles/color";
import { ColorSelect, Text } from "designSystem/index";
import { ComponentItem } from "designSystem/types/component-item-types";
import React from "react";
import CssColumnGrid from "designSystemLegacy/CssColumnGrid";

const colorItems: ComponentItem[] = [
	{ name: "YELLOW", id: yellow[300] },
	{ name: "CYAN", id: cyan[300] },
	{ name: "BLUE", id: blue[300] },
	{ name: "PURPLE", id: purple[400] },
];

const defaultColor: string = colorItems[0].id;

export default () => {
	return (
		<CssColumnGrid columns={1}>
			<Text semiBold text="colorselect" />
			<ColorSelect
				defaultValue={defaultColor}
				items={colorItems}
			/>
		</CssColumnGrid>
	);
};